<div class="contact-confirmation-container">
  <div class="content">
    <kion-info truckImage="./assets/images/contact-confirmation-truck.png" >
     <div>
       <h1>{{ 'contact.confirmation.headline' | translate }}</h1>
       <p>{{ 'contact.confirmation.description' | translate }}</p>
       <kion-button mode="back" [isLink]="true" [link]="backLink" [title]="'contact.confirmation.button.back' | translate"></kion-button>
     </div>
    </kion-info>
  </div>
</div>
